var _react_refresh_temp_1, _react_refresh_temp_2, _react_refresh_temp_3, _react_refresh_temp_4;
var _react_refresh_temp_5;
_react_refresh_temp_5 = $RefreshSig$();
import { jsx as _jsx } from "react/jsx-runtime";
import React, { useRef, useEffect, useState } from 'react';
import { createSelector } from '@reduxjs/toolkit';
import { useAppDispatch, useAppSelector } from '../../store';
import { updatePlayAudioNotification } from '../../store/slices/roomSettingsSlice';
const playAudioNotificationSelector = createSelector(_react_refresh_temp_1 = (state) => state.roomSettings, (roomSettings) => roomSettings.playAudioNotification);
$RefreshReg$(_react_refresh_temp_1, "playAudioNotificationSelector$createSelector");
const allowPlayAudioNotificationSelector = createSelector(_react_refresh_temp_2 = (state) => state.roomSettings, (roomSettings) => roomSettings.allowPlayAudioNotification);
$RefreshReg$(_react_refresh_temp_2, "allowPlayAudioNotificationSelector$createSelector");
const AudioNotification = () => {
    var _a;
    _react_refresh_temp_5();
    const dispatch = useAppDispatch();
    const ref = useRef(null);
    const playAudioNotification = useAppSelector(playAudioNotificationSelector);
    const allowPlayAudioNotification = useAppSelector(allowPlayAudioNotificationSelector);
    const [playing, setPlaying] = useState(false);
    const assetPath = (_a = window.STATIC_ASSETS_PATH) !== null && _a !== void 0 ? _a : './assets';
    useEffect(() => {
        const el = ref.current;
        // we'll play only if audio notification is enabled
        if (playAudioNotification) {
            if (!playing && allowPlayAudioNotification) {
                el === null || el === void 0 ? void 0 : el.play();
            }
            dispatch(updatePlayAudioNotification(false));
        }
    }, [playAudioNotification, playing, allowPlayAudioNotification, dispatch]);
    useEffect(() => {
        const el = ref.current;
        if (el) {
            el.addEventListener('playing', () => setPlaying(true));
            el.addEventListener('ended', () => setPlaying(false));
        }
        return () => {
            if (el) {
                el.pause();
                el.removeEventListener('playing', () => setPlaying(true));
                el.removeEventListener('ended', () => setPlaying(false));
            }
        };
    }, []);
    return (_jsx("div", { style: { display: 'none' }, children: _jsx("audio", { ref: ref, src: `${assetPath}/audio/notification.mp3` }) }));
};
_react_refresh_temp_3 = AudioNotification;
$RefreshReg$(_react_refresh_temp_3, "AudioNotification");
_react_refresh_temp_5(AudioNotification, "kUjPNMD2KBswN/RJU9WkOrA6+58=", false, () => [useAppDispatch, useAppSelector, useAppSelector]);
export default _react_refresh_temp_4 = React.memo(AudioNotification);
$RefreshReg$(_react_refresh_temp_4, "%default%");
